import config from '../config';
import axios from 'axios';
const baseUrl = config.RDPMS_API_URLS;
const MBaseUrl = config.MOBIUS_API_URL;
const RDPMS_APP_VC_API_KEY = config.RDPMS_APP_VC_API_KEY;

const handleAPIResponse = async (result) => {
    const response = result.data;
    try {
        if (response.isSucess === true) {
            return response.response;
        } else if (response.isSucess === false) {
            return response.response;
        } else {
            return response.response;
        }
    } catch (error) {
        console.error(`Error in API call to :`, error);
        return null;
    }
};

// Get User Profile
export async function getUserProfile(id) {
    return await axios.post(baseUrl + `/user/${id}`).then((response) => handleAPIResponse(response));
}

// Create User
export async function createUser(data) {
    return await axios.post(baseUrl + '/users/create', data).then((response) => handleAPIResponse(response));
}

// Update User
export async function updateUser(id, value) {
    // console.log('UPDATE API CALLED WITH ID:', id);
    return axios.post(`${baseUrl}/users/update/${id}`, value).then((response) => handleAPIResponse(response));
}

// Delete User
export async function deleteUser(id) {
    return await axios.post(baseUrl + `/users/delete/${id}`).then((response) => handleAPIResponse(response));
}

export async function checkUserIdAPI(id) {
    return await axios.post(baseUrl + '/users/check/id', id).then((response) => handleAPIResponse(response));
}

// Get All Users (Pagination)
export async function getAllUsers(data) {
    return await axios.post(baseUrl + '/allusers', data).then((response) => handleAPIResponse(response));
}

export async function changePassword(value) {
    return await axios
        .post(baseUrl + '/user/change/password/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function updateProfile(value) {
    return await axios
        .post(baseUrl + '/user/change/profile/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function verifyOtpAPI(value) {
    return await axios.post(baseUrl + '/user/verify/otp', value).then((response) => handleAPIResponse(response));
}

//All API

export async function getDashboardDcCircuitAPI(value) {
    return await axios.post(baseUrl + '/dashboard/dccircuit', value).then((response) => handleAPIResponse(response));
}

export async function getLastDcCircuitAPI() {
    return await axios.post(baseUrl + '/dashboard/dccircuit/dot').then((response) => handleAPIResponse(response));
}

export async function getDashboardPointMachineAPI(value) {
    return await axios.post(baseUrl + '/dashboard/pointmachine', value).then((response) => handleAPIResponse(response));
}

export async function getDashboardBatteryChargerAPI(value) {
    return await axios
        .post(baseUrl + '/dashboard/batterycharger', value)
        .then((response) => handleAPIResponse(response));
}

export async function getDashboardIPSAPI(value) {
    return await axios.post(baseUrl + '/dashboard/ips', value).then((response) => handleAPIResponse(response));
}

export async function getDashboardSignalAPI(value) {
    return await axios.post(baseUrl + '/dashboard/signal', value).then((response) => handleAPIResponse(response));
}

export async function getSignalAlertAPI(value) {
    return await axios.post(baseUrl + '/archieve/signal/alert', value).then((response) => handleAPIResponse(response));
}

//add all master
// add dc circuit

export async function addDCCircuitAPI(value) {
    return await axios
        .post(baseUrl + '/master/dccircuit/create', value)
        .then((response) => handleAPIResponse(response));
}

export async function editDCCircuitAPI(value) {
    return await axios
        .post(baseUrl + '/master/dccircuit/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteDCCircuitAPI(id) {
    return await axios.post(baseUrl + '/master/dccircuit/delete/' + id).then((response) => handleAPIResponse(response));
}

// add all master
// add hassdac

export async function getDashboardHASSDACAPI(value) {
    return await axios.post(baseUrl + '/dashboard/hassdac', value).then((response) => handleAPIResponse(response));
}

// add signal

export async function getStationAPI(id) {
    return await axios.post(baseUrl + '/dashboard/station/' + id).then((response) => handleAPIResponse(response));
}

// add Station
export async function addStationAPI(value) {
    return await axios.post(baseUrl + '/station/create', value).then((response) => handleAPIResponse(response));
}

export async function editStationAPI(value) {
    return await axios
        .post(baseUrl + '/station/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteStationAPI(value) {
    return await axios.post(baseUrl + '/station/delete/' + value).then((response) => handleAPIResponse(response));
}

export async function getAllStationAPI(value) {
    return await axios.post(baseUrl + '/station', value).then((response) => handleAPIResponse(response));
}

export async function getStationNameAPI(value) {
    return await axios.post(baseUrl + '/stations/name', value).then((response) => handleAPIResponse(response));
}

export async function getUserStationAPI(id) {
    return await axios.post(baseUrl + '/user/station/' + id).then((response) => handleAPIResponse(response));
}
export async function getStationForUserAPI() {
    return await axios.post(baseUrl + '/allstation').then((response) => handleAPIResponse(response));
}

export async function getStationOnZoneDivisionAPI(value) {
    return await axios.post(baseUrl + '/zone/division/station', value).then((response) => handleAPIResponse(response));
}

export async function getDashboardDetailsAPI(value) {
    return await axios
        .post(baseUrl + '/landing/dashboard/landing-details', value)
        .then((response) => handleAPIResponse(response));
}

// Vendor
export async function addVendorAPI(value) {
    return await axios.post(baseUrl + '/vendor/create', value).then((response) => handleAPIResponse(response));
}

export async function editVendorAPI(value) {
    return await axios
        .post(baseUrl + '/vendor/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteVendorAPI(value) {
    return await axios.post(baseUrl + '/vendor/delete/' + value).then((response) => handleAPIResponse(response));
}

export async function getAllVendorsAPI() {
    return await axios.post(baseUrl + '/vendor').then((response) => handleAPIResponse(response));
}
export async function getAllVendorsPageAPI(value) {
    return await axios.post(baseUrl + '/allvendor', value).then((response) => handleAPIResponse(response));
}

// Zone
export async function addZoneAPI(value) {
    return await axios.post(baseUrl + '/zone/create', value).then((response) => handleAPIResponse(response));
}

export async function editZoneAPI(value) {
    return await axios
        .post(baseUrl + '/zone/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteZoneAPI(value) {
    return await axios.post(baseUrl + '/zone/delete/' + value).then((response) => handleAPIResponse(response));
}

export async function getAllZonesAPI() {
    return await axios.post(baseUrl + '/zone').then((response) => handleAPIResponse(response));
}
export async function getAllZonesPageAPI(value) {
    return await axios.post(baseUrl + '/allzone', value).then((response) => handleAPIResponse(response));
}

export async function getZoneAPI(id) {
    return await axios.post(baseUrl + '/zone/' + id).then((response) => handleAPIResponse(response));
}

// Division
export async function addDivisionAPI(value) {
    return await axios.post(baseUrl + '/division/create', value).then((response) => handleAPIResponse(response));
}

export async function editDivisionAPI(value) {
    return await axios
        .post(baseUrl + '/division/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteDivisionAPI(value) {
    return await axios.post(baseUrl + '/division/delete/' + value).then((response) => handleAPIResponse(response));
}

export async function getAllDivisionsAPI(id) {
    return await axios.post(baseUrl + '/division', { id }).then((response) => handleAPIResponse(response));
}

export async function getDivisionsForZoneAPI(value) {
    return await axios.post(baseUrl + '/get/zone/division', value).then((response) => handleAPIResponse(response));
}

export async function getAllDivisionsZoneAPI(value) {
    return await axios.post(baseUrl + '/alldivision', value).then((response) => handleAPIResponse(response));
}

export async function getDivisionAPI(id) {
    return await axios.post(baseUrl + '/division/' + id).then((response) => handleAPIResponse(response));
}

export async function getReportAPI(value) {
    return await axios.post(baseUrl + '/reports', value).then((response) => handleAPIResponse(response));
}

export async function getDeviceAPI(value) {
    return await axios.post(baseUrl + '/device', value).then((response) => {
        let deviceResponse = response.data;
        if (deviceResponse.isSucess === true) {
            return deviceResponse.response;
        } else if (deviceResponse.isSucess === false) {
            return deviceResponse.response;
        } else {
            return deviceResponse.response;
        }
    });
}

export async function getReportGraphAPI(value) {
    return await axios.post(baseUrl + '/reports/graph', value).then((response) => handleAPIResponse(response));
}

// notification

export async function acknowledgeNotification(id, value) {
    return await axios
        .post(`${baseUrl}/notification/${id}/acknowledge`, value)
        .then((response) => handleAPIResponse(response));
}

export async function resolveNotification(id, value) {
    return await axios
        .post(`${baseUrl}/notification/${id}/resolve`, value)
        .then((response) => handleAPIResponse(response));
}

export async function getNotification(value) {
    return await axios.post(baseUrl + '/notification', value).then((response) => handleAPIResponse(response));
}

export async function getDeviceDataApi(value) {
    return await axios
        .post(baseUrl + '/notification/all/device', value)
        .then((response) => handleAPIResponse(response));
}

// add feedback
export async function addFeedback(values) {
    const formData = new FormData();
    const files = values.file;
    for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
    }

    formData.append('alert', values.alert);
    formData.append('archievesId', values.archievesId);
    formData.append('name', values.name);
    formData.append('descriptions', values.descriptions);
    formData.append('masterId', values.masterId);
    formData.append('stationId', values.stationId);
    formData.append('notificationId', values.notificationId);
    formData.append('maintainerDesignation', values.maintainerDesignation);
    formData.append('maintainerMobile', values.maintainerMobile);
    formData.append('maintainerName', values.maintainerName);
    formData.append('rectificationDateTime', values.rectificationDateTime);
    formData.append('causeCode', values.causeCode);

    return await axios.post(baseUrl + '/feedback/create', formData).then((response) => handleAPIResponse(response));
}

export async function addFeedbackComments(values) {
    return await axios.post(baseUrl + '/feedback/comments', values).then((response) => handleAPIResponse(response));
}

export async function getFeedback(value) {
    return await axios.post(baseUrl + '/feedback', value).then((response) => handleAPIResponse(response));
}

export async function registerDeviceMobius(value) {
    return await axios
        .post(MBaseUrl + '/device/register', value, {
            headers: {
                'Content-Type': 'application/json',
                'X-M2M-TY': 4,
            },
        })
        .then((response) => {
            return response.data;
        });
}

export async function getMasterEquipmentAPI(value, assetTypes) {
    return await axios
        .post(baseUrl + '/master/' + assetTypes + '/getall', value)
        .then((response) => handleAPIResponse(response));
}

// stop and start alert
export async function startAndStopAlertAPI(value) {
    return await axios
        .post(baseUrl + '/master/device/alertstatus/startAndStopAlert', value)
        .then((response) => handleAPIResponse(response));
}

// export async function addMasterAPI(value) {
//     return await axios.post(baseUrl + '/master/import/file', value).then((response) => handleAPIResponse(response));
// }

export async function addMasterAPI(value) {
    return await axios.post(MBaseUrl + '/master-upload', value).then((response) => {
        return response.data;
    });
}
export async function exportMasterAPI(params) {
    return axios.get(baseUrl + '/master/export/file', {
        params,
        responseType: 'blob',
    });
}

export async function getUserRequestAPI(id) {
    return await axios.post(baseUrl + '/report/request/' + id).then((response) => handleAPIResponse(response));
}

// export async function getAlertSummary(value) {
//     return await axios.post(baseUrl + '/vc_alert_summary', value).then((response) => handleAPIResponse(response));
// }

export async function getAlertSummary(value) {
    return await axios
        .post(baseUrl + '/vc_alert_summary', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

export async function getAlertLive(value) {
    return await axios
        .post(baseUrl + '/vc_alert_live', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

// export async function getAlertDetails(value) {
//     return await axios.post(baseUrl + '/vc_alert_detail', value).then((response) => handleAPIResponse(response));
// }

export async function getAlertDetails(value) {
    return await axios
        .post(baseUrl + '/vc_alert_detail', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

// export async function getMaintenanceMode(value) {
//     return await axios.post(baseUrl + '/maintenance_mode', value).then((response) => handleAPIResponse(response));
// }
export async function getMaintenanceMode(value) {
    return await axios
        .post(baseUrl + '/maintenance_mode', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

export async function getTelemetryLive(value) {
    return await axios
        .post(baseUrl + '/vc_telemetry_live', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

export async function getTelemetryHistory(value) {
    return await axios
        .post(baseUrl + '/vc_telemetry_history', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

export async function getRDPMSHealthLive(value) {
    return await axios
        .post(baseUrl + '/rdpms_health_live', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

export async function getRDPMShealthSummary(value) {
    return await axios
        .post(baseUrl + '/rdpms_health_summary', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

export async function getEquipmentRoomLive(value) {
    return await axios
        .post(baseUrl + '/equipment_room_live', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

export async function getEquipmentRoomHistory(value) {
    return await axios
        .post(baseUrl + '/equipment_room_history', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

export async function getAssets(value) {
    return await axios
        .post(baseUrl + '/vc_asset_detail', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

export async function getAssetUtilization(value) {
    return await axios
        .post(baseUrl + '/asset_utilization', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

export async function getPerformance(value) {
    return await axios
        .post(baseUrl + '/vc_performance', value, {
            headers: {
                'X-API-Key': RDPMS_APP_VC_API_KEY,
            },
        })
        .then((response) => handleAPIResponse(response));
}

export async function getDashboardRelayAPI(value) {
    return await axios.post(baseUrl + '/dashboard/relay', value).then((response) => handleAPIResponse(response));
}
